import {Menu} from '../../core/models/Menu';
import {isMenuFooter} from '../../core/util/MenuUtil';
import {useWPMenus} from './useMenus';

export function useFooterMenus() {
    const allMenus = useWPMenus();
    const footerMenus = allMenus.filter((item: Menu) => isMenuFooter(item));
    return footerMenus;
}
